module.exports = __webpack_public_path__ + "static/img/45.7bab77e0.gif";